module.exports = __webpack_public_path__ + "img/yucatan.688b3955.png";